export default "__VITE_ASSET__Bb75fBLW__"